<template>
  <MainTemplate>
    <div class="main-description">
      <div>
        Мы знаем, как важно найти “того самого мастера”, встречи с которым ждешь с невероятно сладким предвкушением.
        Того, чьим рукам доверяешь безоговорочно, не рискуя испытать разочарование.
      </div>
      <div>
        Поэтому, взяли на себя важную и ответственную роль – соединять дороги мастеров и клиентов, превращая
        их в единый путь красоты, вдохновения и эстетического наслаждения от результата взаимодействия.
      </div>
      <div> Специально для этого мы создали раздел “Мастера”, который будет одинаково полезен как гостям, так и специалистам.</div>
      <div> С его помощью гости могут заочно познакомиться с мастерами, узнать их рейтинг, перечень и стоимость услуг, почитать отзывы.</div>
      <div> Мастера, в свою очередь, получат возможность украсить факты о себе портфолио, который, в большинстве случаев, красноречивее любых слов.</div>
      <div>
        Отдельно отметим важную деталь: зарегистрировавшись на сайте, каждый гость может самостоятельно записаться
        к выбранному мастеру через внутренний мессенджер, обсудить подробности и оплачивать услуги напрямую, без участия со стороны коворкинга.
      </div>
    </div>
    <div class="mobile_top_wrap">
      <flex align="center" justify="between">
        <h1>Мастера <small v-if="paginate">{{ paginate.total }}</small></h1>
        <button class="filter__btn" @click="openFilter">
          <img src="../../assets/images/icons/filter.svg" alt="">
          <span>Фильтры</span>
        </button>
      </flex>
    </div>
    <preload-content :loading="!masters">
      <div class="mobile__hide">
        <flex align="center" mb="30px">
          <custom-select v-if="!!orders && filter.order" @change="(order) => filter.order = order" :value="filter.order" mr="20px">
            <option v-for="order in orders" :key="order.value" :value="order.value">{{ order.name }}</option>
          </custom-select>
          <custom-select v-if="!!getCities" @change="(city) => filter.city_id = city" :value="filter.city_id" mr="20px">
            <option value="" selected>Выберите город</option>
            <option v-for="city in getCities" :key="city.id" :value="city.id">{{ city.name }}</option>
          </custom-select>
          <custom-select
              v-if="!!specializations"
              @change="(specialization) => filter.specialization = specialization"
              :value="filter.specialization"
              mr="25px"
              width="300px"
              max-width="300px"
          >
            <option value="" selected>Выберите специализацию</option>
            <option v-for="specialization in specializations" :key="specialization.id" :value="specialization.id">{{ specialization.name }}</option>
          </custom-select>
          <custom-checkbox v-model="filter.portfolio">Только с портфолио</custom-checkbox>
        </flex>
      </div>
      <row v-if="masters && masters.length">
        <grid-item xs="12" md="6" lg="4" xl="3" v-for="master in masters" :key="master.id">
          <card
              :title="master.full_name"
              :preview="master.avatar"
              :rate="master.rate"
              :link="$router.resolve({name: 'master.show', params: {id: master.id}}).href"
              :tags="master.specializations"
          >
            <template slot="address" v-if="master.coworkings.length">
              <address-component
                  v-for="coworking in master.coworkings"
                  :key="coworking.id"
              >
                <span v-if="coworking.city">г. {{ coworking.city.name }},</span>
                {{ coworking.address }}
              </address-component>
            </template>
          </card>
        </grid-item>
      </row>
      <h3 style="text-align: center;margin-top: 50px" v-else>
        Список пуст
      </h3>
      <pagination v-if="paginate && paginate.last_page > 1" :current="paginate.current_page" :last="paginate.last_page" @click="(page) => filter.page = page"/>
    </preload-content>
  </MainTemplate>
</template>

<script>
import MainTemplate from '../../templates/MainTemplate'
import Row from '../../components/grid/Row'
import GridItem from '../../components/grid/GridItem'
import Flex from '../../components/ui/flex'
import CustomSelect from '../../components/ui/inputs/custom-select'
import Pagination from '../../components/ui/buttons/pagination'
import Card from '../../components/ui/card/card'
import CustomCheckbox from '../../components/ui/inputs/custom-checkbox'
import {mapGetters, mapMutations} from "vuex"
import preloadContent from '../../components/ui/preload-content';
import AddressComponent from '@/components/ui/text/address-component';

export default {
  name: 'Catalog',
  components: {CustomCheckbox, MainTemplate, Flex, CustomSelect, Pagination, Row, GridItem, Card, preloadContent, AddressComponent},
  computed: {
    ...mapGetters([
      'getCity',
      'getCities',
    ]),
    filterComputed() {
      return Object.assign({}, this.filter);
    }
  },
  watch: {
    filterComputed: {
      handler: function (newValue, oldValue) {
        if (newValue.page !== 1 && newValue.page === oldValue.page) return this.filter.page = 1;
        this.loadMasters();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadSpecializations();
    this.loadMasters();
    this.$eventHub.$on('master.filters.changed', (filter) => {
      this.filter = filter;
      this.loadMasters();
    });
  },
  data() {
    return {
      paginate: null,
      masters: null,
      specializations: null,
      orders: [
        {name: 'По рейтингу', value: 'rate,desc'},
        {name: 'Сначала новые', value: 'id,desc'},
        {name: 'Сначала старые', value: 'id,asc'},
      ],
      filter: {
        page: 1,
        order: 'rate,desc',
        portfolio: 0,
        city_id: this.$store.getters.getCity,
        specialization: null,
        search: null,
      },
    }
  },
  methods: {
    ...mapMutations(['openModal', 'setModalData']),
    loadSpecializations() {
      this.$api.specialization.all().then(({data}) => this.specializations = data);
    },
    loadMasters() {
      this.masters = null;
      let filter = Object.assign({}, this.filter);
      filter.portfolio = filter.portfolio ? 1 : '';
      this.$api.master.list(Object.assign({
        column: filter.order.split(',')[0],
        direction: filter.order.split(',')[1],
      }, filter)).then((data) => {
        this.masters = data.data;
        this.paginate = data.meta;
      });
    },
    openFilter() {
      this.openModal('mobileFilters')
      this.setModalData({filter: this.filter, page: 'master', orders: this.orders, specializations: this.specializations});
    }
  },
  beforeDestroy() {
    this.$eventHub.$off('master.filters.changed');
  }
}
</script>

<style scoped lang="scss">
.filter__btn {
  display: none;
}

.main-description {
  margin-bottom: -20px;
  margin-top: 30px;
   div{
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 991px) {
  h1 {
    font-size: 24px;
    padding-top: 0;
    margin-bottom: 0;
  }
  .filter__btn {
    font-family: "Open Sans", sans-serif;
    display: flex;
    align-items: center;
    border: none;
    background-color: transparent;
    font-weight: 600;
    font-size: 16px;
    color: #B9765B;

    img {
      margin-right: 5px;
    }
  }
  .mobile_top_wrap {
    padding: 20px 0;
  }
  .mobile__hide {
    display: none;
  }
}
</style>
